import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import * as Yup from "yup";

import useCreateRedirect from "../services/useCreateRedirect";

export type CreateRedirectForm = {
	name: string;
	redirectURI: string;
};

export default function useCreateRedirectForm() {
	const { translate } = useLocales();

	const schema = Yup.object().shape({
		name: Yup.string().required(translate("api_client.add_name")),
		redirectURI: Yup.string()
			.matches(
				/^(?:[a-zA-Z0-9]+:\/\/)?(?:localhost(?::\d+)?|(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})*|[a-zA-Z0-9-]+)(?:\/[a-zA-Z0-9#-_]+)*\/?(?:\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
				translate("api_client.add_correct_url")
			)
			.required(translate("api_client.add_one_url"))
	});

	const methods = useForm<CreateRedirectForm>({
		resolver: yupResolver(schema),
		defaultValues: { redirectURI: "", name: "" }
	});

	const { onCreateRedirect, isLoading } = useCreateRedirect({ reset: methods.reset });

	async function onSubmit({ name, redirectURI }: CreateRedirectForm) {
		onCreateRedirect(name, redirectURI);
	}

	return {
		methods,
		onSubmit: methods.handleSubmit(onSubmit),
		isLoading
	};
}
